import { render, staticRenderFns } from "./OrganismSystemResource.vue?vue&type=template&id=6877ffa8&scoped=true&"
import script from "./OrganismSystemResource.vue?vue&type=script&lang=js&"
export * from "./OrganismSystemResource.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSystemResource.vue?vue&type=style&index=0&id=6877ffa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877ffa8",
  null
  
)

export default component.exports